<script lang="ts">
  import { cn } from '@shared/utils';

  export let variant: 'primary' | 'secondary' | 'tertiary' = 'primary';
  export let hasHover = true;

  const styleClasses = {
    primary: {
      hover: 'hover:bg-emerald-100 dark:hover:bg-emerald-400/30',
      default:
        'bg-emerald-400/[9%] text-emerald-800 border-emerald-300 dark:text-emerald-300 dark:bg-bg-emerald-400/10 dark:border-emerald-400/30',
    },
    secondary: {
      hover: 'hover:bg-violet-100 dark:hover:bg-violet-400/30',
      default:
        'bg-violet-50 text-violet-800 border-violet-100 dark:text-violet-400 dark:bg-violet-400/20 dark:border-violet-400/10',
    },
    tertiary: {
      hover: 'hover:bg-blue-750/15 dark:hover:bg-blue-650/30',
      default:
        'bg-blue-750/10  text-blue-750 border-blue-750/20 dark:text-blue-650 dark:bg-blue-650/20 dark:border-blue-650/25',
    },
  } as const;
</script>

<button
  on:click
  class="{cn(
    'inline-flex items-center gap-1.5 rounded-md border px-1.5 py-1.5 text-sm font-medium transition-colors',
    styleClasses[variant].default,
    {
      [styleClasses[variant].hover]: hasHover,
      'pointer-events-none cursor-default': !hasHover,
    },
  )}"
>
  <slot />
</button>
